<template>
    <modal height="auto" width="60%" :scrollable="true" name="action-contravention" classes="modal_default" :clickToClose="true">
        <div class="card">
            <div class="card-header">
                <h3></h3>
            </div>
            <div class="card-body">
                <table class="table table-bordered">
                    <template v-for="(limitContraventionPerType, key) in limitContravention">
                        <template v-if="limitContraventionPerType.type === 'frequency'">
                            <tr v-for="lcpAction in limitContraventionPerType.actions">
                                <td>
                                    {{ limitContraventionPerType.comment }}
                                </td>
                                <td>
                                    {{ lcpAction.visit_date }}
                                </td>
                                <td>
                                    <template v-if="lcpAction.visit_id == $route.params.visitid">
                                        tato návštěva
                                    </template>
                                    <template v-else="">
                                        <router-link :to="{ name: 'VisitDiagnosis', params: { clientid: $route.params.clientid, visitid: lcpAction.visit_id }}" target='_blank'>
                                            zobrazit návštěvu <i class="fa fa-external-link" aria-hidden="true"></i>
                                        </router-link>
                                    </template>
                                </td>
                            </tr>
                        </template>
                        <template v-else-if="limitContraventionPerType.type === 'non_contracted'">
                            <tr>
                                <td>
                                    {{ limitContraventionPerType.comment }}
                                </td>
                            </tr>
                        </template>
                    </template>
                </table>
            </div>
        </div>
    </modal>
</template>

<script>
  // import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        //
      }
    },
    props: ['limitContravention'],
    // mixins: [apiMixin],
    watch: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }


</style>



// WEBPACK FOOTER //
// src/views/Visit/modals/ActionContravention.vue?ba0a2d8c